module.exports = __webpack_public_path__ + "static/media/back-to-home-page-desktop.f0d8a0ca.svg";